import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 10000 }, // デフォルト10秒
    fadeOut: { type: Number, default: 1000 },  // フェードアウト時間（ミリ秒）
    autoHide: { type: Boolean, default: false } // 自動非表示するかどうか
  }

  connect() {
    // コントローラーが接続されたら自動的にタイマーを開始
    if (this.autoHideValue) {
      this.startTimer()
    }
  }

  disconnect() {
    // タイマーをクリア
    this.clearTimer()
  }

  startTimer() {
    // 既存のタイマーをクリア
    this.clearTimer()

    // 新しいタイマーを開始
    this.timer = setTimeout(() => {
      this.hide()
    }, this.durationValue)
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  hide() {
    // フェードアウトアニメーション
    this.element.style.transition = `opacity ${this.fadeOutValue}ms ease-out`
    this.element.style.opacity = '0'

    // フェードアウト完了後に要素を削除
    setTimeout(() => {
      this.element.remove()
    }, this.fadeOutValue)
  }

  // 手動で非表示にする場合のメソッド
  dismiss() {
    this.hide()
  }

  // タイマーをリセットする場合のメソッド
  reset() {
    if (this.autoHideValue) {
      this.startTimer()
    }
  }

  // 自動非表示を有効/無効にするメソッド
  enableAutoHide() {
    this.autoHideValue = true
    this.startTimer()
  }

  disableAutoHide() {
    this.autoHideValue = false
    this.clearTimer()
  }
}
